<template lang="pug">
  v-card
    v-card-title
      h2.modal-title {{ 'base.add_animal_type' | translate }}
    v-card-content
      v-type-select(
        ref="typeSelect"
        v-model="form.name"
        :label="$t('base.type_animal_type_name')"
        :hint="errorMessage('name')"
        :invalid="!!errorMessage('name')"
        :custom-types="[]"
        :default-types="defaultAnimalTypes"
        :auto-close-on-select="false"
        :close-on-reselect="true"
        @select="onSelectType"
        @create-enabled="onCreateEnabled"
        @create-new="onCreateNew")
    
    v-card-actions
      v-btn(
        @click="onCreate"
        :loading="loading"
        :disabled="!canCreate") {{ 'base.create' | translate }}
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import formErrorsMixin from '@/mixins/form-errors.mixin.js'

export default {
  name: 'CreateTypeModal',

  mixins: [formErrorsMixin],

  data: () => ({
    form: {
      name: ''
    },
    errors: {
      name: null
    },
    loading: false,
    selectedType: null,
    isDefaultType: false,
    createEnabled: false
  }),

  computed: {
    ...mapGetters('animaltypes', [
      'animalTypes',
      'defaultAnimalTypes'
    ]),

    canCreate () {
      return this.form.name && this.createEnabled
    }
  },

  mounted () {
    this.loadDefaultAnimalTypes()
  },

  methods: {
    ...mapActions('animaltypes', [
      'createAnimalType',
      'loadDefaultAnimalTypes'
    ]),

    onSelectType ({ type, isDefault }) {
      this.selectedType = type
      this.isDefaultType = isDefault

      this.$nextTick(() => {
        if (this.$refs.typeSelect && this.$refs.typeSelect.$el) {
          const input = this.$refs.typeSelect.$el.querySelector('input')
          if (input) {
            input.focus()
            input.setSelectionRange(input.value.length, input.value.length)
          }
        }
      })
    },

    onCreateEnabled (enabled) {
      this.createEnabled = enabled
      if (!enabled) {
        this.errors.name = null
      }
    },

    onCreateNew (typeName) {
      this.$nextTick(() => {
        if (this.$refs.typeSelect && this.$refs.typeSelect.$el) {
          const input = this.$refs.typeSelect.$el.querySelector('input')
          if (input) {
            input.focus()
            input.setSelectionRange(input.value.length, input.value.length)
          }
        }
      })
    },

    async onCreate () {
      this.loading = true

      this.checkValidData()

      if (this.errors.name === null) {
        const payload = {
          farm: this.$route.params.farm_id,
          name: this.form.name
        }

        const error = await this.createAnimalType(payload)

        if (!error) {
          this.$emit('update')
          this.$emit('close')
        } else {
          this.$toasted.error(this.$t('errors.incorrect_data'))
        }
      }

      this.loading = false
    },

    checkValidData () {
      this.errors.name = null
      if (!this.form.name) {
        this.errors.name = ['3']
      } else if (this.form.name.length > 100) {
        this.errors.name = ['6', 100]
      }
    }
  }
}
</script>
<style scoped>
.v-card__title {
  padding: 2rem 2.4rem 1.6rem;
}

.modal-title {
  font-size: 2rem;
  font-weight: 700;
  margin: 0;
}

.v-card__content {
  border-top: .1rem solid #d7d7d7;
  padding-bottom: 1.5rem !important;
}

.v-card__actions {
  padding: 0 2.4rem 2.4rem;
}

.v-card__actions button {
  width: 100%;
}
</style>